import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { AuthService } from "../../providers/auth.service";
import { RoutingService } from "../../providers/routing.service";
import { Subscription } from "rxjs";

@Component({
    selector: "app-connection-router",
    templateUrl: "./connection-router.component.html",
    styleUrls: ["./connection-router.component.scss"]
})
export class ConnectionRouterComponent implements OnInit {
  @Input() loginRoute!: string;
  @Input() logoutRoute!: string;
  userSub!: Subscription;
  constructor(private auth: AuthService, private routing: RoutingService) {}

  ngOnInit() {
    this.userSub = this.auth.user.subscribe((userData) => {
      if (userData && userData.uid) {
        if (this.auth.altRoute) {
          let tmpPath = this.auth.altRoute;
          this.auth.altRoute = null as any;
          this.routing.toPath(tmpPath);
        } else if (this.loginRoute) this.routing.toPath(this.loginRoute);
      } else if (this.logoutRoute) {
        if (this.logoutRoute === "external") {
          this.routing.toExternalHome();
        } else {
          this.routing.toPath(this.logoutRoute);
        }
      }
    });
  }
  ngOnDestroy() {
    if (this.userSub) this.userSub.unsubscribe();
  }
}
